import PropTypes from 'prop-types'
import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import style from './base_icon.scss'

class BaseIcon extends Component {

	render() {
		return (
			<i styleName={
				classNames({
					filled: this.props.fillColor?true:false,
					[this.props.fillColor]: this.props.fillColor?true:false,
					container: true,
					'w-input': this.props.withInput,
				})
			}>
				<img src={this.props.src} styleName='icon-image' />
			</i>
		)
	}

}

BaseIcon.propTypes = {
	fillColor: PropTypes.string,
	src: PropTypes.string,
}

BaseIcon.defaultProps = {
	withInput: false,
}

export default CSSModules(BaseIcon, style, {allowMultiple: true})
